module.exports = __webpack_public_path__ + "static/media/termsconditions.01a36944.pdf";